import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import {
  emptyNotesAndLabels,
  SidePanelConfig,
  ActiveClaim,
  SidePanelErrors,
} from './side-panel.constants';

export class SidePanel {
  showOverview: boolean;
  showCustom: boolean;
  showDownloads: boolean;
  showResources: boolean;
  showLabelsAndNotes: boolean;
  firstLabel: string;
  overviewCustomContent: any;
  overviewAttributeList: ModelAttributeConfig[];
  customCustomContent: any;
  customAttributeList: ModelAttributeConfig[];
  downloadsCustomContent: any;
  downloadsAttributeList: ModelAttributeConfig[];
  resourcesCustomContent: any;
  resourcesAttributeList: ModelAttributeConfig[];
  labelsAndNotesData: any;
  labelsAndNotesCustomContent: any;
  activeClaim: ActiveClaim;

  constructor(
    config: SidePanelConfig,
    labelsList: any,
    notes: any,
    activeClaim: ActiveClaim,
  ) {
    this.activeClaim = activeClaim || {};
    this.showOverview = config?.overview?.label?.length > 0;
    this.showCustom = config?.custom?.label?.length > 0;
    this.showDownloads = config?.downloads?.label?.length > 0;
    this.showResources = config?.resources?.label.length > 0;
    this.showLabelsAndNotes = config?.labelsAndNotes?.label?.length > 0;
    this.firstLabel = config?.overview?.label || 'Overview';
    this.overviewCustomContent = config?.overview?.customContent || null;
    this.overviewAttributeList =
      config?.overview?.attributeList?.attributes || [];
    this.customCustomContent = config?.custom?.customContent || null;
    this.customAttributeList = config?.custom?.attributeList?.attributes || [];
    this.downloadsCustomContent = config?.downloads?.customContent || null;
    this.downloadsAttributeList =
      config?.downloads?.attributeList?.attributes || [];
    this.resourcesCustomContent = config?.resources?.customContent || null;
    this.resourcesAttributeList =
      config?.resources?.attributeList?.attributes || [];

    // Ensure the structure exists
    if (!config?.labelsAndNotes) {
      this.labelsAndNotesData = emptyNotesAndLabels;
      this.labelsAndNotesCustomContent = null;
    } else {
      this.labelsAndNotesCustomContent = config?.labelsAndNotes?.customContent;
      this.labelsAndNotesData = {
        labels: {
          title: config?.labelsAndNotes?.labelForLabels,
          data: labelsList,
        },
        notes: {
          title: config?.labelsAndNotes?.labelForNotes,
          data: notes,
        },
      };
    }
  }
}

export interface SidePanelArgs {
  config: SidePanelConfig;
  context: unknown;
  errors: SidePanelErrors;
  labelsList: string[];
  notes: string;
  activeClaim: ActiveClaim;
  addNewButtonClicked?: (value: string) => void;
  editButtonClicked?: (value: string) => void;
  resourceItemClicked?: (value: ModelAttributeConfig) => void;
  customItemClicked?: (value: string) => void;
}
